// extracted by extract-css-chunks-webpack-plugin
module.exports = {"left_box":"left_box-uwU5bAgJ","dbox":"dbox-3JtI__bB"};